import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import { useEffect, useRef, useState } from 'react';

export default function PhoneInput({ 
  onChange, 
  onValidation,
  defaultCountry = 'in',
  preferredCountries = ['in', 'us', 'gb', 'ae'],
  required = true,
  placeholder = 'Enter phone number',
  className = '',
  inputClassName = '',
  errorClassName = '',
  successClassName = '',
  showError = false,
  showSuccess = false
}) {
  const inputRef = useRef(null);
  const itiRef = useRef(null);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState('');
  const [touched, setTouched] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState({ dialCode: '', name: '', code: '' });

  useEffect(() => {
    if (inputRef.current && !itiRef.current) {
      // Initialize intl-tel-input
      itiRef.current = intlTelInput(inputRef.current, {
        initialCountry: defaultCountry,
        preferredCountries: preferredCountries,
        separateDialCode: true,
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.2.1/js/utils.js',
        autoPlaceholder: 'aggressive',
        formatOnDisplay: true,
        nationalMode: false,
        customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
          return 'e.g. ' + selectedCountryPlaceholder;
        },
      });

      // Update country info on initialization
      updateCountryInfo();

      // Add event listener for country change
      inputRef.current.addEventListener('countrychange', () => {
        updateCountryInfo();
        if (touched) {
          validatePhone();
        }
      });
    }

    return () => {
      if (itiRef.current) {
        itiRef.current.destroy();
        itiRef.current = null;
      }
    };
  }, []);

  const updateCountryInfo = () => {
    if (itiRef.current) {
      const countryData = itiRef.current.getSelectedCountryData();
      const country = {
        dialCode: '+' + countryData.dialCode,
        name: countryData.name,
        code: countryData.iso2.toUpperCase()
      };
      setSelectedCountry(country);
      
      // Emit to parent even when country changes
      emitToParent(phoneNumber, false, country);
    }
  };

  const emitToParent = (number, valid, country = selectedCountry) => {
    const phoneData = {
      phoneNumber: number,
      dialCode: country.dialCode,
      countryCode: country.code,
      countryName: country.name,
      fullNumber: country.dialCode + number,
      isValid: valid
    };

    // Emit phone data to parent
    if (onChange) {
      onChange(phoneData);
    }
  };


 const handleInput = (e) => {
  const value = e.target.value;
  setPhoneNumber(value);

  // Emit data to parent without validation
  emitToParent(value, false); // don't mark invalid yet
};



  const handleBlur = () => {
    setTouched(true);
  };

  const handleFocus = () => {
    // Optional: You can emit focus event if needed
  };

  return (
    <div className={className}>
      <input
        ref={inputRef}
        type="tel"
        id="phone"
        value={phoneNumber}
        onInput={handleInput}
        onBlur={handleBlur}
        onFocus={handleFocus}
        className={inputClassName}
        placeholder={placeholder}
      />

      {showError && error && touched && (
        <div className={errorClassName}>
          {error}
        </div>
      )}

      {showSuccess && isValid && touched && !error && (
        <div className={successClassName}>
          Valid {selectedCountry.name} phone number
        </div>
      )}

      <style>{`
        .iti {
          width: 732px;
        }
        .iti__flag-container {
          padding: 0;
        }
        .iti__selected-flag {
          padding: 0 0 0 12px;
        }

        .iti__selected-country{
        border-right:1px solid #DBDBDB;
        padding-right:5px
        }

        .iti__country-list {
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          margin-top: 4px;
          border: 1px solid #e5e7eb;
          z-index: 9999;

          
        }
        .iti__country {
          padding: 8px 12px;
        }
      `}</style>
    </div>
  );
}